export interface BlogArticle {
  id: string;
  slug: string;
  title: string;
  metaTitle: string;
  metaDescription: string;
  excerpt: string;
  content: string;
  category: string;
  readTime: string;
  publishedAt: string;
  updatedAt: string;
  tags: string[];
  featuredImage?: string;
}

export const blogArticles: BlogArticle[] = [
  {
    id: "1",
    slug: "o-que-sao-papulas-peroladas-penianas",
    title: "O Que São Pápulas Peroladas P-nile (PPP)? Guia Médico Completo",
    metaTitle: "O Que São Pápulas P-nile? Causas, Sintomas e Fatos [2025]",
    metaDescription: "Saiba o que são as pápulas peroladas p-nile (PPP), por que elas aparecem e se são perigosas. Fatos médicos sobre essa condição comum, que afeta 14-48% dos homens.",
    excerpt: "Pápulas peroladas p-nile são pequenas protuberâncias em forma de cúpula que aparecem ao redor da cabeça do p-nis. Saiba por que elas ocorrem e se você deve se preocupar.",
    category: "Educação",
    readTime: "8 min",
    publishedAt: "2025-01-15",
    updatedAt: "2025-12-29",
    tags: ["PPP", "pápulas peroladas p-nile", "caroços no p-nis", "saúde masculina"],
    content: `
      <h2>O Que São Pápulas Peroladas P-nile?</h2>
      <p>As <strong>pápulas peroladas p-nile (PPP)</strong>, também conhecidas como hirsuties coronae glandis ou papilomas hirsutoides, são pequenas protuberâncias cor da pele ou brancas que aparecem em uma ou mais fileiras ao redor da coroa (crista) da cabeça do p-nis.</p>
      
      <p>Essas protuberâncias são uma <strong>variação anatômica normal</strong>, não uma doença ou infecção. Elas estão presentes desde o nascimento, mas geralmente se tornam visíveis durante a puberdade, quando as mudanças hormonais as tornam mais proeminentes.</p>

      <h2>Qual a Frequência das PPP?</h2>
      <p>Pesquisas mostram que <strong>14% a 48% dos homens</strong> têm pápulas peroladas p-nile em algum grau. Isso significa que quase metade de todos os homens pode ter essa condição. É uma das variações anatômicas mais comuns da genitália masculina.</p>
      
      <p>As PPP são mais comuns em:</p>
      <ul>
        <li>Homens não circuncidados (embora homens circuncidados também possam tê-las)</li>
        <li>Homens de descendência africana</li>
        <li>Homens mais jovens (elas podem se tornar menos proeminentes com a idade)</li>
      </ul>

      <h2>Qual a Causa das Pápulas Peroladas P-nile?</h2>
      <p>As PPP <strong>não são causadas por</strong> nenhuma infecção, má higiene ou atividade sexual. Elas são simplesmente uma variação anatômica genética, assim como algumas pessoas têm covinhas ou sardas.</p>
      
      <p>A função biológica exata das PPP não é totalmente compreendida, mas alguns pesquisadores acreditam que elas podem ser estruturas vestigiais — remanescentes de espinhos p-nile que estavam presentes em nossos ancestrais evolutivos.</p>

      <h2>Características Principais das PPP</h2>
      <ul>
        <li><strong>Tamanho:</strong> 1-2mm de diâmetro, tamanho uniforme</li>
        <li><strong>Cor:</strong> Cor da pele, branca ou ligeiramente rosa</li>
        <li><strong>Padrão:</strong> Dispostas em fileiras nítidas ao redor da coroa</li>
        <li><strong>Textura:</strong> Lisa, em forma de cúpula (não áspera ou semelhante a couve-flor)</li>
        <li><strong>Sintomas:</strong> Nenhum — sem dor, coceira ou secreção</li>
        <li><strong>Comportamento:</strong> Não crescem, não se espalham ou mudam com o tempo</li>
      </ul>

      <h2>As PPP São Perigosas?</h2>
      <p><strong>Não, as pápulas peroladas p-nile são completamente inofensivas.</strong> Elas são:</p>
      <ul>
        <li>NÃO são uma infecção sexualmente transmissível (IST)</li>
        <li>NÃO são contagiosas</li>
        <li>NÃO são causadas por má higiene</li>
        <li>NÃO são um sinal de doença</li>
        <li>NÃO são cancerosas ou pré-cancerosas</li>
      </ul>
      
      <p>As PPP não afetam a função sexual, a fertilidade ou a micção. Elas não representam absolutamente nenhum risco para a saúde.</p>

      <h2>Você Deve Tratar as PPP?</h2>
      <p>Do ponto de vista médico, as <strong>PPP não requerem tratamento</strong>. No entanto, muitos homens optam por removê-las por razões estéticas ou psicológicas. Os métodos de tratamento comuns incluem:</p>
      <ul>
        <li><strong>Eletrocauterização</strong> - Método mais eficaz, 100% de taxa de sucesso</li>
        <li><strong>Tratamento a laser de CO2</strong> - Eficaz, mas caro (US$ 1.500 a US$ 3.000)</li>
        <li><strong>Crioterapia</strong> - Menos comum, pode exigir múltiplas sessões</li>
      </ul>

      <h2>O Que as PPP NÃO São</h2>
      <p>É importante entender que as PPP são diferentes de:</p>
      <ul>
        <li><strong>Verrugas genitais (HPV):</strong> As verrugas são ásperas, de formato irregular e podem aparecer em qualquer lugar da genitália</li>
        <li><strong>Herpes:</strong> Causa bolhas dolorosas que aparecem e desaparecem</li>
        <li><strong>Molusco contagioso:</strong> Protuberâncias com uma depressão central</li>
        <li><strong>Manchas de Fordyce:</strong> Aparecem na haste, não ao redor da coroa</li>
      </ul>

      <h2>Quando Consultar um Médico</h2>
      <p>Embora as PPP sejam inofensivas, você deve consultar um médico se suas protuberâncias:</p>
      <ul>
        <li>Apareceram repentinamente após contato sexual</li>
        <li>São dolorosas, coçam ou queimam</li>
        <li>Têm uma textura áspera ou semelhante a couve-flor</li>
        <li>Estão crescendo ou se espalhando</li>
        <li>Estão acompanhadas de secreção</li>
      </ul>
    `
  },
  {
    id: "2",
    slug: "glandulas-de-tyson-vs-verrugas-genitais",
    title: "Glândulas de Tyson vs. Verrugas Genitais: Como Diferenciá-las",
    metaTitle: "Glândulas de Tyson vs. Verrugas Genitais: Diferenças Chave [Com Imagens]",
    metaDescription: "Aprenda a distinguir as glândulas de Tyson das verrugas genitais. Entenda as principais diferenças na aparência, localização e sintomas para identificar o que você tem.",
    excerpt: "Preocupado com caroços no seu p-nis? Saiba as principais diferenças entre as inofensivas glândulas de Tyson e as verrugas genitais que requerem tratamento.",
    category: "Comparação",
    readTime: "6 min",
    publishedAt: "2025-01-20",
    updatedAt: "2025-12-29",
    tags: ["glândulas de Tyson", "verrugas genitais", "HPV", "DST vs normal"],
    content: `
      <h2>A Diferença Crítica Que Você Precisa Saber</h2>
      <p>Quando você nota protuberâncias no seu p-nis, a primeira pergunta geralmente é: "Isso é uma DST?" A boa notícia é que a maioria das protuberâncias p-niles são <strong>variações anatômicas completamente normais</strong>, não infecções.</p>
      
      <p>Duas das condições mais comumente confundidas são as <strong>glândulas de Tyson</strong> (também chamadas de pápulas peroladas p-nile ou PPP) e as <strong>verrugas genitais</strong> (causadas pelo HPV). Veja como diferenciá-las.</p>

      <h2>O Que São Glândulas de Tyson?</h2>
      <p>As glândulas de Tyson são pequenas protuberâncias lisas, em forma de cúpula, que ocorrem naturalmente ao redor da coroa (crista) da cabeça do p-nis. Elas são:</p>
      <ul>
        <li>Presentes desde o nascimento (tornam-se visíveis durante a puberdade)</li>
        <li>Completamente inofensivas e não contagiosas</li>
        <li>Encontradas em 14-48% dos homens</li>
        <li>NÃO são sexualmente transmissíveis</li>
      </ul>

      <h2>O Que São Verrugas Genitais?</h2>
      <p>As verrugas genitais são causadas por certas cepas do Papilomavírus Humano (HPV), especificamente os tipos 6 e 11. Elas são:</p>
      <ul>
        <li>Sexualmente transmissíveis</li>
        <li>Contagiosas para parceiros</li>
        <li>Podem aparecer em qualquer lugar da genitália</li>
        <li>Podem exigir tratamento médico</li>
      </ul>

      <h2>Comparação Lado a Lado</h2>
      <table>
        <thead>
          <tr>
            <th>Característica</th>
            <th>Glândulas de Tyson (Normal)</th>
            <th>Verrugas Genitais (HPV)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Início</strong></td>
            <td>Desde a puberdade</td>
            <td>Apareceram após contato sexual</td>
          </tr>
          <tr>
            <td><strong>Localização</strong></td>
            <td>Apenas ao redor da coroa</td>
            <td>Em qualquer lugar da genitália/ânus</td>
          </tr>
          <tr>
            <td><strong>Padrão</strong></td>
            <td>Fileiras nítidas, simétricas</td>
            <td>Aleatório, aglomerado</td>
          </tr>
          <tr>
            <td><strong>Textura</strong></td>
            <td>Lisa, em forma de cúpula</td>
            <td>Áspera, semelhante a couve-flor</td>
          </tr>
          <tr>
            <td><strong>Tamanho</strong></td>
            <td>Uniforme, 1-2mm</td>
            <td>Tamanhos variáveis</td>
          </tr>
          <tr>
            <td><strong>Cor</strong></td>
            <td>Cor da pele ou ligeiramente branca</td>
            <td>Cinza, rosa ou cor da pele</td>
          </tr>
          <tr>
            <td><strong>Crescimento</strong></td>
            <td>Nunca mudam ou se espalham</td>
            <td>Podem crescer e multiplicar</td>
          </tr>
          <tr>
            <td><strong>Contagioso?</strong></td>
            <td>Não</td>
            <td>Sim, altamente contagioso</td>
          </tr>
        </tbody>
      </table>

      <h2>O Teste Rápido</h2>
      <p>Pergunte-se estas questões:</p>
      <ol>
        <li><strong>Você tem essas protuberâncias desde a adolescência?</strong> → Provavelmente glândulas de Tyson</li>
        <li><strong>Elas apareceram recentemente após atividade sexual?</strong> → Podem ser verrugas, consulte um médico</li>
        <li><strong>Elas estão em fileiras nítidas ao redor da crista da cabeça?</strong> → Glândulas de Tyson</li>
        <li><strong>Elas estão espalhadas aleatoriamente?</strong> → Podem ser verrugas</li>
        <li><strong>Elas são lisas e uniformes?</strong> → Glândulas de Tyson</li>
        <li><strong>Elas são ásperas ou irregulares?</strong> → Podem ser verrugas</li>
      </ol>

      <h2>Quando Consultar um Médico</h2>
      <p>Você deve consultar um profissional de saúde se:</p>
      <ul>
        <li>As protuberâncias apareceram repentinamente após contato sexual</li>
        <li>Elas estão crescendo, se espalhando ou se multiplicando</li>
        <li>Elas têm uma textura irregular e áspera</li>
        <li>Você tem outros sintomas (dor, coceira, secreção)</li>
        <li>Você simplesmente não tem certeza do que tem</li>
      </ul>
      <p>Um médico pode geralmente diagnosticar a condição com um exame visual simples.</p>

      <h2>Em Resumo</h2>
      <p>Se você tem pequenas protuberâncias lisas e uniformes dispostas em fileiras ao redor da sua coroa desde a puberdade, elas são quase certamente <strong>glândulas de Tyson — completamente normais e inofensivas</strong>.</p>
      <p>Se você tiver alguma dúvida, especialmente se as protuberâncias apareceram recentemente ou após atividade sexual, consulte um médico para sua tranquilidade.</p>
    `
  },
  {
    id: "3",
    slug: "manchas-de-fordyce-no-penis",
    title: "Manchas de Fordyce no P-nis: O Que São e Por Que Você as Tem",
    metaTitle: "Manchas de Fordyce no P-nis: Causas, Tratamento e Fatos [Guia 2025]",
    metaDescription: "Tudo o que você precisa saber sobre as manchas de Fordyce no p-nis. Saiba por que essas pequenas protuberâncias brancas/amarelas aparecem e se precisam de tratamento.",
    excerpt: "Manchas de Fordyce são pequenas protuberâncias pálidas na haste do p-nis que muitos homens confundem com uma DST. Saiba por que elas são completamente normais.",
    category: "Educação",
    readTime: "7 min",
    publishedAt: "2025-02-01",
    updatedAt: "2025-12-29",
    tags: ["manchas de Fordyce", "caroços no p-nis", "glândulas sebáceas", "saúde masculina"],
    content: `
      <h2>O Que São Manchas de Fordyce?</h2>
      <p>As <strong>manchas de Fordyce</strong> (também chamadas de grânulos de Fordyce) são pequenas protuberâncias de cor amarela pálida ou branca que podem aparecer na haste do p-nis, escroto e até nos lábios e dentro das bochechas. Elas são glândulas sebáceas aumentadas ou ectópicas — as mesmas glândulas produtoras de óleo encontradas em toda a pele.</p>
      
      <p>Ao contrário da maioria das glândulas sebáceas, as manchas de Fordyce não estão associadas a folículos pilosos, razão pela qual se tornam visíveis como pequenas protuberâncias em áreas da pele sem pelos.</p>

      <h2>Qual a Frequência das Manchas de Fordyce?</h2>
      <p><strong>Até 80% dos adultos</strong> têm manchas de Fordyce em alguma parte do corpo. Elas são tão comuns que são consideradas uma variação anatômica normal, não uma condição médica.</p>
      
      <p>A maioria das pessoas tem algumas manchas de Fordyce, mas elas podem ser tão pequenas ou poucas que não são perceptíveis. Em algumas pessoas, elas são mais proeminentes e facilmente visíveis.</p>

      <h2>Qual a Causa das Manchas de Fordyce?</h2>
      <p>As manchas de Fordyce estão presentes desde o nascimento, mas geralmente se tornam mais visíveis durante a puberdade, quando as glândulas sebáceas se tornam mais ativas devido a mudanças hormonais.</p>
      
      <p>Elas <strong>NÃO são causadas por:</strong></p>
      <ul>
        <li>Qualquer infecção ou DST</li>
        <li>Má higiene</li>
        <li>Atividade sexual</li>
        <li>Qualquer doença ou enfermidade</li>
      </ul>
      <p>Elas são simplesmente uma variação genética na forma como suas glândulas sebáceas se desenvolveram.</p>

      <h2>Características das Manchas de Fordyce</h2>
      <ul>
        <li><strong>Tamanho:</strong> 1-3mm de diâmetro</li>
        <li><strong>Cor:</strong> Amarela pálida, branca ou cor da pele</li>
        <li><strong>Localização:</strong> Haste do p-nis, escroto, lábios, bochechas internas</li>
        <li><strong>Padrão:</strong> Frequentemente aparecem em grupos</li>
        <li><strong>Textura:</strong> Ligeiramente elevadas, lisas</li>
        <li><strong>Visibilidade:</strong> Mais visíveis quando a pele está esticada</li>
      </ul>

      <h2>Manchas de Fordyce vs. PPP: Qual a Diferença?</h2>
      <p>Embora ambas sejam inofensivas, elas ocorrem em locais diferentes:</p>
      <ul>
        <li><strong>Manchas de Fordyce:</strong> Aparecem na HASTE do p-nis (não na cabeça)</li>
        <li><strong>PPP/Glândulas de Tyson:</strong> Aparecem ao redor da coroa (crista da cabeça)</li>
      </ul>
      <p>Um homem pode ter ambas as condições, e nenhuma delas requer tratamento.</p>

      <h2>Você Deve Tratar as Manchas de Fordyce?</h2>
      <p>As manchas de Fordyce são <strong>completamente inofensivas e não requerem tratamento</strong>. No entanto, algumas pessoas optam pelo tratamento cosmético por razões pessoais.</p>
      
      <p>Opções de tratamento (se desejado) incluem:</p>
      <ul>
        <li><strong>Tratamento a laser:</strong> Lasers de CO2 ou pulsados</li>
        <li><strong>Eletrodessecação:</strong> Usando corrente elétrica</li>
        <li><strong>Microcirurgia por punção:</strong> Remoção física</li>
      </ul>
      <p>Nota: Esses tratamentos são apenas cosméticos e geralmente não são cobertos por seguro.</p>

      <h2>Advertências Importantes</h2>
      <p><strong>NÃO tente espremer, estourar ou arranhar as manchas de Fordyce.</strong> Isso pode causar:</p>
      <ul>
        <li>Infecção</li>
        <li>Cicatrizes</li>
        <li>Inflamação</li>
        <li>Dor</li>
      </ul>
      <p>Ao contrário das espinhas, as manchas de Fordyce não estão infectadas e espremê-las só causará danos.</p>

      <h2>Quando Consultar um Médico</h2>
      <p>Embora as manchas de Fordyce não exijam atenção médica, consulte um médico se as protuberâncias no seu p-nis:</p>
      <ul>
        <li>São dolorosas ou coçam</li>
        <li>Apareceram repentinamente após contato sexual</li>
        <li>Estão crescendo ou se espalhando</li>
        <li>Têm uma cor ou textura incomum</li>
        <li>Estão acompanhadas de outros sintomas</li>
      </ul>
    `
  },
  {
    id: "4",
    slug: "carocos-no-penis-sao-normais",
    title: "Carroços no Meu P-nis São Normais? Um Guia Avaliado por Médicos",
    metaTitle: "Carroços no Meu P-nis São Normais? Guia Completo [2025]",
    metaDescription: "Preocupado com carroços no seu p-nis? Entenda quais tipos são completamente normais (a maioria!) e quais sintomas indicam que você deve procurar um médico.",
    excerpt: "A maioria dos caroços p-nis são variações anatômicas completamente normais. Aprenda a identificar o que é normal versus o que pode precisar de atenção médica.",
    category: "Educação",
    readTime: "10 min",
    publishedAt: "2025-02-15",
    updatedAt: "2025-12-29",
    tags: ["caroços p-nile", "anatomia normal", "saúde masculina", "sintomas de DST"],
    content: `
      <h2>A Resposta Curta: A Maioria dos Caroços É Normal</h2>
      <p>Se você notou caroços no seu p-nis e imediatamente entrou em pânico, respire fundo. <strong>A grande maioria dos caroços p-nile são variações anatômicas completamente normais</strong>, não sinais de doença ou infecção.</p>
      
      <p>O problema é que a educação sexual raramente aborda como é a anatomia masculina normal, deixando muitos homens a assumir o pior quando notam algo diferente.</p>

      <h2>Carroços Normais Que Não Requerem Tratamento</h2>
      
      <h3>1. Pápulas Peroladas P-nile (PPP) / Glândulas de Tyson</h3>
      <p>Pequenas protuberâncias lisas, em forma de cúpula, dispostas em fileiras ao redor da coroa (crista da cabeça do p-nis). Encontradas em 14-48% dos homens. Completamente inofensivas.</p>
      
      <h3>2. Manchas de Fordyce</h3>
      <p>Protuberâncias amarelo-pálidas ou brancas na haste. São glândulas sebáceas visíveis. Encontradas em até 80% dos adultos.</p>
      
      <h3>3. Glândulas Sebáceas</h3>
      <p>Pequenas protuberâncias brancas ou amarelas que produzem óleo. Todo p-nis as possui — algumas são apenas mais visíveis do que outras.</p>
      
      <h3>4. Folículos Pilosos</h3>
      <p>Pequenas protuberâncias na base dos pelos na haste e no escroto. Completamente normais.</p>
      
      <h3>5. Angioqueratomas</h3>
      <p>Pequenas manchas vermelho-escuras ou roxas causadas por vasos sanguíneos dilatados. Geralmente aparecem no escroto. Inofensivos.</p>

      <h2>Sinais de Que os Caroços São Normais</h2>
      <p>Seus caroços são provavelmente normais se eles:</p>
      <ul>
        <li>✓ Estiverem presentes desde a puberdade</li>
        <li>✓ Tiverem tamanho e forma uniformes</li>
        <li>✓ Estiverem dispostos em um padrão (como fileiras)</li>
        <li>✓ Não tiverem mudado com o tempo</li>
        <li>✓ Não causarem sintomas (sem dor, coceira ou secreção)</li>
        <li>✓ Tiverem uma textura lisa</li>
      </ul>

      <h2>Sinais de Alerta Que Precisam de Atenção Médica</h2>
      <p>Consulte um médico se seus caroços:</p>
      <ul>
        <li>✗ Apareceram repentinamente, especialmente após contato sexual</li>
        <li>✗ São dolorosos, coçam ou queimam</li>
        <li>✗ Têm uma textura áspera ou semelhante a couve-flor</li>
        <li>✗ Estão crescendo, se espalhando ou multiplicando</li>
        <li>✗ Estão cheios de líquido ou pus</li>
        <li>✗ Estão acompanhados de secreção do p-nis</li>
        <li>✗ Vieram com sintomas semelhantes aos da gripe</li>
      </ul>

      <h2>Condições Que EXIGEM Atenção Médica</h2>
      
      <h3>Verrugas Genitais (HPV)</h3>
      <p>Protuberâncias ásperas, semelhantes a couve-flor, causadas pelo Papilomavírus Humano. Sexualmente transmissíveis e contagiosas.</p>
      
      <h3>Herpes (HSV)</h3>
      <p>Bolhas dolorosas que aparecem em surtos, depois cicatrizam e retornam. Causadas pelo Vírus Herpes Simples.</p>
      
      <h3>Molusco Contagioso</h3>
      <p>Pequenas protuberâncias firmes, em forma de cúpula, com uma depressão central. Levemente contagioso.</p>
      
      <h3>Cancro Sifilítico</h3>
      <p>Uma única ferida indolor que aparece no local da infecção. Requer tratamento imediato.</p>

      <h2>O Ponto Principal</h2>
      <p>Se você tem os mesmos caroços pequenos e lisos desde a puberdade e eles não mudaram, eles são quase certamente anatomia normal. Mas se você tiver alguma dúvida – especialmente se os caroços apareceram recentemente ou após atividade sexual – consulte um profissional de saúde. Eles geralmente podem diagnosticar a condição com um exame visual simples e lhe dar tranquilidade.</p>
    `
  },
  {
    id: "5",
    slug: "remocao-ppp-em-casa-guia-completo",
    title: "Remoção de PPP em Casa: É Seguro? Guia Completo",
    metaTitle: "Remoção de PPP em Casa: Métodos Seguros e o que Evitar [2025]",
    metaDescription: "Considera a remoção de PPP em casa? Saiba sobre métodos seguros, o que dermatologistas usam e abordagens DIY perigosas a evitar.",
    excerpt: "Muitos homens querem remover PPP, mas não podem pagar por visitas caras à clínica. Conheça as opções caseiras e os métodos a evitar.",
    category: "Tratamento",
    readTime: "9 min",
    publishedAt: "2025-03-01",
    updatedAt: "2025-12-29",
    tags: ["remoção de PPP", "tratamento caseiro", "eletrocauterização", "DIY"],
    content: `
      <h2>Por Que Homens Consideram a Remoção de PPP em Casa</h2>
      <p>A remoção profissional de PPP pode custar entre <strong>US$ 600 e US$ 3.000</strong>, dependendo do método e da localização. Para muitos homens, isso simplesmente não é acessível, especialmente porque:</p>
      <ul>
        <li>O seguro não cobre procedimentos cosméticos</li>
        <li>Múltiplas sessões podem ser necessárias</li>
        <li>A condição pode retornar, exigindo retratamento</li>
      </ul>
      <p>Isso leva muitos a pesquisar alternativas caseiras.</p>

      <h2>Métodos de Tratamento Profissional</h2>
      <p>Antes de discutir as opções caseiras, vamos entender o que os profissionais usam:</p>
      
      <h3>1. Eletrocauterização (Mais Eficaz)</h3>
      <p>Utiliza corrente elétrica para destruir as pápulas. <strong>100% de taxa de sucesso</strong> quando realizada corretamente. Este é o tratamento padrão ouro.</p>
      
      <h3>2. Laser de CO2</h3>
      <p>Usa energia laser para vaporizar as protuberâncias. Eficaz, mas muito caro (US$ 1.500 a US$ 3.000).</p>
      
      <h3>3. Crioterapia</h3>
      <p>Congelamento com nitrogênio líquido. Menos preciso, pode exigir múltiplas sessões.</p>

      <h2>Métodos Caseiros: O Que Realmente Funciona</h2>
      <p>A realidade é que a mesma técnica usada em clínicas — a eletrocauterização — pode ser realizada em casa com equipamentos de grau médico e conhecimento adequado.</p>
      
      <h3>Eletrocauterização Caseira</h3>
      <p>Canetas de cauterização de grau médico estão disponíveis para compra. Quando usadas corretamente com protocolos adequados, elas podem alcançar os mesmos resultados que os tratamentos clínicos por uma fração do custo.</p>
      
      <p><strong>Suprimentos necessários:</strong></p>
      <ul>
        <li>Caneta de cauterização de grau médico (US$ 30 a US$ 50)</li>
        <li>Solução antisséptica (US$ 10 a US$ 15)</li>
        <li>Anestésico tópico (US$ 15 a US$ 20)</li>
        <li>Gaze estéril (US$ 5 a US$ 10)</li>
      </ul>
      <p><strong>Custo total: Menos de US$ 200</strong> (vs US$ 600 a US$ 3.000 em uma clínica)</p>

      <h2>Métodos Que NÃO Funcionam (Não Gaste Seu Dinheiro)</h2>
      <ul>
        <li><strong>Cremes e pomadas:</strong> Nenhum produto tópico remove as PPP</li>
        <li><strong>Óleo de melaleuca:</strong> Não faz nada pelas PPP</li>
        <li><strong>Óleo de rícino:</strong> Não funciona</li>
        <li><strong>Pasta de dente:</strong> Mito perigoso, pode causar queimaduras químicas</li>
        <li><strong>Vinagre de maçã:</strong> Não funciona, pode danificar a pele</li>
      </ul>
      <p>Esses "remédios naturais" são populares online, mas não têm base científica e não removerão as PPP.</p>

      <h2>Métodos Perigosos a EVITAR</h2>
      <p><strong>NUNCA tente o seguinte:</strong></p>
      <ul>
        <li>Cortar ou raspar com objetos afiados</li>
        <li>Usar dispositivos elétricos não médicos</li>
        <li>Queimar com fogo ou objetos aquecidos</li>
        <li>Congelar com gelo ou produtos de congelamento de venda livre</li>
        <li>Aplicar ácidos ou produtos químicos cáusticos</li>
      </ul>
      <p>Isso pode causar queimaduras graves, cicatrizes, infecção e danos permanentes.</p>

      <h2>O Que Torna a Remoção Caseira Segura?</h2>
      <p>A remoção caseira segura requer:</p>
      <ol>
        <li><strong>Equipamento adequado:</strong> Caneta de cauterização de grau médico (não ferramentas improvisadas)</li>
        <li><strong>Técnica correta:</strong> Protocolo passo a passo para atingir as pápulas</li>
        <li><strong>Ambiente estéril:</strong> Área de trabalho limpa, equipamento esterilizado</li>
        <li><strong>Anestesia adequada:</strong> Creme anestésico tópico</li>
        <li><strong>Protocolo de pós-cuidado:</strong> Cuidados com a ferida para prevenir infecção e cicatrizes</li>
      </ol>

      <h2>Recuperação e Cicatrização</h2>
      <p>Com técnica e pós-cuidado adequados:</p>
      <ul>
        <li>Cicatrização inicial: 7-10 dias</li>
        <li>Recuperação completa: 21 dias</li>
        <li>Resultados finais: Pele lisa sem cicatrizes</li>
      </ul>

      <h2>Quem NÃO Deve Tentar a Remoção Caseira</h2>
      <ul>
        <li>Aqueles com distúrbios de coagulação sanguínea</li>
        <li>Aqueles propensos a cicatrizes queloides</li>
        <li>Qualquer pessoa incerta de seu diagnóstico (consulte um médico primeiro!)</li>
        <li>Aqueles desconfortáveis com procedimentos de auto-tratamento</li>
      </ul>

      <h2>Em Resumo</h2>
      <p>A remoção de PPP em casa usando equipamentos e técnicas médicas adequadas pode ser segura e eficaz quando feita corretamente. A chave é usar as ferramentas certas, seguir os protocolos adequados e manter condições estéreis. Se você estiver incerto, consulte um dermatologista primeiro para confirmar seu diagnóstico.</p>
    `
  },
  {
    id: "6",
    slug: "as-mulheres-se-importam-com-ppp",
    title: "As Mulheres se Importam com PPP? O Que os Parceiros Realmente Pensam",
    metaTitle: "As Mulheres se Importam com PPP? Resultados de Pesquisas e Opiniões Reais [2025]",
    metaDescription: "Preocupado com o que os parceiros pensam sobre suas PPP? Saiba o que pesquisas e mulheres reais dizem sobre pápulas peroladas p-nile e intimidade.",
    excerpt: "Uma das maiores preocupações para homens com PPP é o que os parceiros pensarão. Aqui está o que pesquisas e experiências reais revelam.",
    category: "Relacionamentos",
    readTime: "6 min",
    publishedAt: "2025-03-15",
    updatedAt: "2025-12-29",
    tags: ["PPP", "relacionamentos", "intimidade", "reações de parceiros"],
    content: `
      <h2>O Medo Que Todo Homem Com PPP Tem</h2>
      <p>Se você tem pápulas peroladas p-nile, provavelmente já se preocupou com o que os parceiros pensarão. Perguntas como:</p>
      <ul>
        <li>"Elas vão pensar que tenho uma DST?"</li>
        <li>"Elas vão ficar com nojo?"</li>
        <li>"Devo explicar antes de ficarmos íntimos?"</li>
        <li>"Elas vão me rejeitar?"</li>
      </ul>
      <p>Esses medos são incrivelmente comuns — e muitas vezes muito piores do que a realidade.</p>

      <h2>O Que a Pesquisa Mostra</h2>
      <p>Estudos sobre as reações dos parceiros às PPP revelam algumas descobertas interessantes:</p>
      <ul>
        <li><strong>A maioria dos parceiros não percebe:</strong> Em pesquisas, muitos parceiros relatam nunca terem notado as PPP de seus parceiros até que fossem apontadas</li>
        <li><strong>A educação elimina a preocupação:</strong> Quando os parceiros aprendem que as PPP são anatomia normal, as preocupações desaparecem</li>
        <li><strong>A autoconsciência é o maior problema:</strong> A própria ansiedade de um homem em relação às PPP afeta a intimidade mais do que as próprias PPP</li>
      </ul>

      <h2>Experiências Reais de Mulheres</h2>
      <p>Em vários fóruns e pesquisas, as mulheres costumam dizer:</p>
      
      <blockquote>"Namorei um cara com PPP por 2 anos antes de sequer notar. Quando perguntei, ele explicou o que eram. Sem problema."</blockquote>
      
      <blockquote>"Meu marido as tem. Nunca pensei nelas durante a intimidade. Elas são apenas parte dele."</blockquote>
      
      <blockquote>"A única coisa que me incomodaria seria se um cara fosse tão autoconsciente sobre isso que não conseguisse relaxar e se divertir."</blockquote>

      <h2>O Real Impacto nos Relacionamentos</h2>
      <p>Aqui está o que realmente importa nos relacionamentos íntimos:</p>
      <ol>
        <li><strong>Confiança:</strong> A autoconfiança é mais atraente do que a "perfeição" física</li>
        <li><strong>Comunicação:</strong> Ser capaz de discutir preocupações abertamente constrói confiança</li>
        <li><strong>Conhecimento:</strong> Entender que as PPP são normais ajuda ambos os parceiros</li>
      </ol>

      <h2>Você Deve Contar aos Parceiros Sobre as PPP?</h2>
      <p>Esta é uma escolha pessoal. Considere:</p>
      
      <h3>Razões para mencionar:</h3>
      <ul>
        <li>Alivia sua própria ansiedade</li>
        <li>Previne potencial confusão</li>
        <li>Abre a comunicação sobre o corpo</li>
      </ul>
      
      <h3>Razões pelas quais você pode não precisar:</h3>
      <ul>
        <li>A maioria dos parceiros não notará ou se importará</li>
        <li>É anatomia normal, não uma condição a "revelar"</li>
        <li>Chamar a atenção para isso pode criar preocupação onde não existia</li>
      </ul>

      <h2>Como Explicar as PPP Se Perguntado</h2>
      <p>Se um parceiro perguntar, seja simples e confiante:</p>
      <p><em>"São pápulas peroladas p-nile — são anatomia totalmente normal que muitos caras têm. Não é uma DST ou algo contagioso. Assim como algumas pessoas têm sardas."</em></p>
      <p>Entregue com confiança, esta explicação satisfaz a curiosidade sem criar drama.</p>

      <h2>Quando a Remoção de PPP Faz Sentido</h2>
      <p>Alguns homens optam por remover as PPP não porque os parceiros exigem, mas porque:</p>
      <ul>
        <li>Eles se sentem mais confiantes sem elas</li>
        <li>Elimina a ansiedade de "e se elas notarem"</li>
        <li>É uma preferência pessoal para sua própria satisfação</li>
      </ul>
      <p>Esta é uma escolha válida — apenas certifique-se de que você está fazendo isso por você, não porque você acha que "tem que".</p>

      <h2>Em Resumo</h2>
      <p>A verdade é: <strong>a maioria dos parceiros ou não nota as PPP ou não se importa com elas</strong>. Sua própria ansiedade sobre isso é quase sempre pior do que qualquer reação real do parceiro. Concentre-se na confiança, comunicação e em desfrutar da intimidade — as PPP raramente importam para alguém além da pessoa que as tem.</p>
    `
  },
  {
    id: "7",
    slug: "por-que-carocos-apareceram-no-meu-penis",
    title: "Por Que Notei Carroços no Meu P-nis Repentinamente?",
    metaTitle: "Notou Carroços no P-nis Repentinamente? Saiba o Porquê [Guia 2025]",
    metaDescription: "Acabou de notar caroços no seu p-nis e está em pânico? Saiba por que você está vendo eles agora e se eles são motivo de preocupação.",
    excerpt: "Muitos homens notam de repente caroços que tiveram por anos. Saiba por que isso acontece e se você deveria se preocupar.",
    category: "Educação",
    readTime: "5 min",
    publishedAt: "2025-04-01",
    updatedAt: "2025-12-29",
    tags: ["caroços p-nile", "PPP", "ansiedade", "saúde masculina"],
    content: `
      <h2>A Descoberta "Repentina" Que Não é Nova</h2>
      <p>Você está no chuveiro, e de repente nota caroços no seu p-nis que jura que não estavam lá antes. O pânico se instala. Você começa a pesquisar no Google. Sua mente corre para as piores possibilidades.</p>
      
      <p>Aqui está o que a maioria dos homens não percebe: <strong>esses caroços provavelmente estão lá há anos</strong>.</p>

      <h2>Por Que Você Está Notando Eles Agora</h2>
      <p>Vários fatores podem fazer com que você de repente perceba algo que estava lá o tempo todo:</p>
      
      <h3>1. Novo Relacionamento ou Atividade Sexual</h3>
      <p>Quando você se torna sexualmente ativo ou inicia um novo relacionamento, você fica mais consciente do seu corpo. Você se examina mais de perto, levando a descobertas que você perdeu antes.</p>
      
      <h3>2. Ansiedade ou Preocupações de Saúde</h3>
      <p>Preocupar-se com DSTs ou problemas de saúde o torna hiperconsciente. Você olha mais de perto do que o normal, e a anatomia normal de repente parece preocupante.</p>
      
      <h3>3. Melhor Iluminação ou Ângulos</h3>
      <p>Às vezes é tão simples quanto olhar em uma iluminação melhor ou de um ângulo diferente pela primeira vez.</p>
      
      <h3>4. Pesquisas na Internet Mal Sucedidas</h3>
      <p>Ler sobre sintomas de DST online pode fazer com que você se examine mais de perto, encontrando coisas que sempre estiveram lá.</p>

      <h2>Sinais de Que os Caroços Estão Lá Desde a Puberdade</h2>
      <p>Se seus caroços são:</p>
      <ul>
        <li>Pequenos, uniformes e dispostos em padrões</li>
        <li>Da mesma cor da sua pele (ou ligeiramente mais claros)</li>
        <li>Lisos e em forma de cúpula</li>
        <li>Não dolorosos, com coceira ou produzindo secreção</li>
        <li>Não estão crescendo ou se espalhando</li>
      </ul>
      <p>...eles são quase certamente anatomia normal que você está notando pela primeira vez.</p>

      <h2>Sinais de Que Algo Realmente Mudou Recentemente</h2>
      <p>Consulte um médico se os caroços:</p>
      <ul>
        <li>Apareceram após contato sexual com um novo parceiro</li>
        <li>São dolorosos, coçam ou queimam</li>
        <li>Têm uma textura irregular ou áspera</li>
        <li>Estão crescendo ou se multiplicando</li>
        <li>Estão cheios de líquido ou pus</li>
        <li>Parecem diferentes de outros inchaços no seu p-nis</li>
      </ul>

      <h2>Os Culpados Mais Comuns</h2>
      <p>Na grande maioria dos casos, os caroços "notados de repente" são:</p>
      <ol>
        <li><strong>Pápulas Peroladas P-nile (PPP):</strong> Ao redor da coroa, 14-48% dos homens as têm</li>
        <li><strong>Manchas de Fordyce:</strong> Na haste, até 80% dos adultos as têm</li>
        <li><strong>Folículos Pilosos:</strong> Na base da haste, 100% dos homens as têm</li>
        <li><strong>Glândulas Sebáceas:</strong> Glândulas de óleo visíveis, extremamente comuns</li>
      </ol>

      <h2>Como Parar de Se Preocupar</h2>
      <ol>
        <li><strong>Pare de examinar excessivamente:</strong> Quanto mais você olha, mais "anormal" as coisas normais parecem</li>
        <li><strong>Eduque-se:</strong> Aprenda como é a anatomia normal</li>
        <li><strong>Consulte um médico uma vez:</strong> Obtenha uma opinião profissional para sua tranquilidade</li>
        <li><strong>Aceite a variação normal:</strong> Cada corpo é diferente</li>
      </ol>

      <h2>Em Resumo</h2>
      <p>Se você "de repente" notou caroços que são pequenos, uniformes, lisos e indolores, você provavelmente acabou de tomar consciência de uma anatomia normal que você tem desde a puberdade. O corpo humano tem muitas variações normais — o p-nis não é exceção. Se você ainda está preocupado, uma visita ao médico pode confirmar o que você tem e proporcionar tranquilidade duradoura.</p>
    `
  },
  {
    id: "8",
    slug: "ppp-desaparece-sozinha",
    title: "As PPP Podem Desaparecer Sozinhas? O Que Esperar Com o Tempo",
    metaTitle: "As PPP Podem Desaparecer Sozinhas? Progressão Natural [2025]",
    metaDescription: "Quer saber se as pápulas peroladas p-nile desaparecerão naturalmente? Saiba o que acontece com as PPP ao longo do tempo e suas opções se elas não sumirem.",
    excerpt: "Muitos homens esperam que as PPP desapareçam sozinhas. Aqui está o que a pesquisa diz sobre a progressão natural das pápulas peroladas p-nile.",
    category: "Educação",
    readTime: "5 min",
    publishedAt: "2025-04-15",
    updatedAt: "2025-12-29",
    tags: ["PPP", "tratamento natural", "saúde masculina"],
    content: `
      <h2>A Resposta Curta</h2>
      <p><strong>Não, as PPP não desaparecem sozinhas.</strong> Elas são uma característica anatômica permanente, não uma condição temporária.</p>
      
      <p>No entanto, há uma nuance: alguns homens relatam que suas PPP se tornam <em>menos perceptíveis</em> com a idade, embora não desapareçam completamente.</p>

      <h2>O Que a Pesquisa Diz</h2>
      <p>Estudos sobre a história natural das PPP mostram:</p>
      <ul>
        <li>As PPP aparecem durante a puberdade e permanecem por toda a vida</li>
        <li>Elas não se espalham, crescem ou se multiplicam com o tempo</li>
        <li>Em alguns homens, elas podem se tornar ligeiramente menos proeminentes com a idade</li>
        <li>Elas nunca se resolvem completamente sem tratamento</li>
      </ul>

      <h2>Por Que as PPP Não Desaparecem</h2>
      <p>As PPP não são causadas por uma infecção, inflamação ou condição temporária. Elas são:</p>
      <ul>
        <li>Parte da sua anatomia, como sardas ou covinhas</li>
        <li>Formadas durante o desenvolvimento fetal</li>
        <li>Tornadas visíveis pelos hormônios da puberdade</li>
      </ul>
      <p>Assim como as sardas não desaparecem sozinhas, as PPP também não.</p>

      <h2>Algo Pode Torná-las Menos Visíveis?</h2>
      <p>Alguns fatores podem afetar a visibilidade das PPP:</p>
      
      <h3>Pode torná-las MENOS visíveis:</h3>
      <ul>
        <li>Envelhecimento (as glândulas podem encolher ligeiramente)</li>
        <li>Ganho de peso (pele esticada)</li>
      </ul>
      
      <h3>Pode torná-las MAIS visíveis:</h3>
      <ul>
        <li>Ereção (pele esticada as revela)</li>
        <li>Perda de peso (menos acolchoamento)</li>
        <li>Melhor iluminação (você as vê com mais clareza)</li>
      </ul>
      
      <p>Nenhuma dessas mudanças elimina as PPP — elas apenas afetam a visibilidade.</p>

      <h2>Produtos Que Afirmam Remover as PPP</h2>
      <p>Você pode ver produtos comercializados como "cremes para remoção de PPP" ou "tratamentos naturais para PPP". <strong>Nenhum deles funciona.</strong></p>
      <ul>
        <li>Óleo de melaleuca: Sem efeito nas PPP</li>
        <li>Óleo de rícino: Sem efeito nas PPP</li>
        <li>Alfa-hidroxiácidos: Sem efeito nas PPP</li>
        <li>Qualquer creme tópico: Sem efeito nas PPP</li>
      </ul>
      <p>Economize seu dinheiro — nenhum creme, óleo ou produto tópico remove as PPP.</p>

      <h2>A Única Forma de Remover as PPP</h2>
      <p>A destruição física das pápulas é o único tratamento eficaz:</p>
      <ol>
        <li><strong>Eletrocauterização:</strong> Usa corrente elétrica (mais eficaz)</li>
        <li><strong>Laser de CO2:</strong> Usa energia laser (caro)</li>
        <li><strong>Crioterapia:</strong> Usa congelamento (menos preciso)</li>
      </ol>
      <p>Todos esses métodos destroem fisicamente as pápulas, razão pela qual funcionam.</p>

      <h2>Vivendo Com PPP</h2>
      <p>Se você optar por não remover as PPP, saiba que:</p>
      <ul>
        <li>Elas não causam problemas de saúde</li>
        <li>Elas não afetam a função sexual</li>
        <li>A maioria dos parceiros não percebe ou se importa</li>
        <li>Você está na companhia de 14-48% dos homens</li>
      </ul>

      <h2>Em Resumo</h2>
      <p>As PPP não desaparecerão sozinhas. Se você quiser removê-las, o tratamento físico (eletrocauterização, laser, etc.) é a única opção. Se você optar por viver com elas, elas não representam risco para a saúde e a maioria dos parceiros não notará ou se importará.</p>
    `
  }
];

export const getArticleBySlug = (slug: string): BlogArticle | undefined => {
  return blogArticles.find(article => article.slug === slug);
};

// Legacy English blog slugs → current pt-BR slugs (used for 301-style redirects)
export const legacyBlogSlugs: Record<string, string> = {
  "what-are-pearly-penile-papules": "o-que-sao-papulas-peroladas-penianas",
  "tyson-glands-vs-genital-warts-difference": "glandulas-de-tyson-vs-verrugas-genitais",
  "fordyce-spots-on-penis-explained": "manchas-de-fordyce-no-penis",
  "are-bumps-on-my-penis-normal": "carocos-no-penis-sao-normais",
  "ppp-removal-at-home-complete-guide": "remocao-ppp-em-casa-guia-completo",
  "do-women-care-about-ppp": "as-mulheres-se-importam-com-ppp",
  "why-did-i-suddenly-notice-bumps-on-my-penis": "por-que-carocos-apareceram-no-meu-penis",
  "can-ppp-go-away-on-its-own": "ppp-desaparece-sozinha"
};

export const getRelatedArticles = (currentSlug: string, count: number = 3): BlogArticle[] => {
  const currentArticle = getArticleBySlug(currentSlug);
  if (!currentArticle) return blogArticles.slice(0, count);
  
  // Prioritize same category, then other articles
  const sameCategory = blogArticles.filter(
    a => a.slug !== currentSlug && a.category === currentArticle.category
  );
  const otherArticles = blogArticles.filter(
    a => a.slug !== currentSlug && a.category !== currentArticle.category
  );
  
  return [...sameCategory, ...otherArticles].slice(0, count);
};